let callLeaveHandler: (() => void) | null = null;

export const setCallHeaderLeaveHandler = (handler: (() => void) | null) => {
  callLeaveHandler = handler;
};

export const triggerCallHeaderLeave = () => {
  callLeaveHandler?.();
};
